// @todo can be reused on cerberus
import {pick, compose} from 'ramda'
import {} from '@modifi/onboarding-api-clients'
import {
  DIRECT_DEBIT_ACCOUNT_INPUT_FIELD_NAMES,
  FIELD_NAME_TO_PROPERTY_NAME_MAPPING,
} from './constant'

export const pickAllDirectDebitAccountProperties = pick([...DIRECT_DEBIT_ACCOUNT_INPUT_FIELD_NAMES])

const fieldNameToProperty = (fieldName: string): string => {
  if (FIELD_NAME_TO_PROPERTY_NAME_MAPPING[fieldName]) {
    return FIELD_NAME_TO_PROPERTY_NAME_MAPPING[fieldName]
  }
  return fieldName.replace('directDebitBankDetails.', '')
}

export const mapDirectDebitAccountToRequest = (
  formData: Record<string, any>
): Record<string, any> =>
  Object.fromEntries(
    Object.entries(formData).map(([fieldName, value]) => [fieldNameToProperty(fieldName), value])
  )

const propertyToFieldName = (propertyName: string): string => {
  if (Object.values(FIELD_NAME_TO_PROPERTY_NAME_MAPPING).includes(propertyName)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return Object.entries(FIELD_NAME_TO_PROPERTY_NAME_MAPPING).find(
      ([, value]) => value === propertyName
    )![0]
  }
  return `directDebitBankDetails.${propertyName}`
}

const mapDirectDebitAccountPropertiesToInputFieldNames = (
  directDebitAccount: Record<string, any>
): Record<string, any> =>
  Object.fromEntries(
    Object.entries(directDebitAccount).map(([propertyName, value]) => [
      propertyToFieldName(propertyName),
      value,
    ])
  )

export const mapDirectDebitAccountToFormData = compose(
  pickAllDirectDebitAccountProperties,
  mapDirectDebitAccountPropertiesToInputFieldNames
)
